<script lang="ts">
  import { AppState } from '../../etc/stores';

  export let width = '74';
  export let height = '74';

  const { gradientColor1, gradientColor2 } =
    $AppState.theme.colors.backgroundCoin;
</script>

<svg
  {width}
  {height}
  viewBox="0 0 74 75"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask
    id="mask0_261_12328"
    style="mask-type:alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="74"
    height="75"
  >
    <circle cx="36.6923" cy="37.4809" r="36.6923" fill="#205BE0" />
  </mask>
  <g mask="url(#mask0_261_12328)">
    <circle
      cx="36.6923"
      cy="37.4809"
      r="36.6923"
      fill="url(#paint0_linear_261_12328)"
    />
    <g filter="url(#filter0_i_261_12328)">
      <circle
        cx="36.6922"
        cy="37.481"
        r="34.1238"
        fill="white"
        fill-opacity="0.01"
      />
    </g>
    <circle
      cx="36.6922"
      cy="37.481"
      r="33.7569"
      stroke="white"
      stroke-width="0.733846"
      style="mix-blend-mode:overlay"
    />
    <circle
      cx="51.3693"
      cy="17.9116"
      r="45.8654"
      fill="url(#paint1_radial_261_12328)"
      fill-opacity="0.3"
      style="mix-blend-mode:overlay"
    />
    <circle
      cx="17.1236"
      cy="74.1733"
      r="61.1539"
      fill="url(#paint2_radial_261_12328)"
      fill-opacity="0.4"
      style="mix-blend-mode:multiply"
    />
  </g>
  <defs>
    <filter
      id="filter0_i_261_12328"
      x="2.56836"
      y="0.299485"
      width="71.3054"
      height="71.3054"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="4.89231" dy="-4.89231" />
      <feGaussianBlur stdDeviation="1.52885" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_261_12328"
      />
    </filter>
    <linearGradient
      id="paint0_linear_261_12328"
      x1="58.7573"
      y1="-93.9998"
      x2="-15.0071"
      y2="-85.8704"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={gradientColor1} />
      <stop offset="1" stop-color={gradientColor2} />
    </linearGradient>
    <radialGradient
      id="paint1_radial_261_12328"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(51.3693 17.9116) rotate(83.2338) scale(35.0863)"
    >
      <stop stop-color="white" />
      <stop offset="1" stop-color="white" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="paint2_radial_261_12328"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(17.1236 74.1733) rotate(83.2338) scale(46.7818)"
    >
      <stop stop-color="#202020" />
      <stop offset="1" stop-color="#202020" stop-opacity="0" />
    </radialGradient>
  </defs>
</svg>
